import { RootState } from 'redux/types';

export const getSnackBars = (store: RootState) => store.snackBars;
